import { formToObject, invokeJsonEncoding, invokeMultipartEncoding, isSafari } from '../js-utils/_shared/form-utils';

interface Props {
    apiUrl?: string;
    isMultipartEncoding?: boolean;
    event?: string;
}

export default function init(container: HTMLElement, { apiUrl, isMultipartEncoding, event = 'load' }: Props) {
    const formElement = container.querySelector('form') as HTMLFormElement;
    if (!formElement || !apiUrl) {
        return;
    }

    const repostFormElement: HTMLFormElement = container.querySelector('form.js-repost-form')!;
    const jsonData: HTMLInputElement = container.querySelector('.js-json-data')!;
    const failurePHolder: HTMLElement = container.querySelector('.js-failure-pholder')!;
    const submitHide: HTMLElement = container.querySelector('.js-submit-hide')!;
    const processingHide: HTMLElement = container.querySelector('.js-processing-hide')!;
    const processingShow: HTMLElement = container.querySelector('.js-processing-show')!;

    // call API function
    const callApi = async () => {
        let errorMsg = '';

        if (failurePHolder) {
            failurePHolder.style.display = 'none';
        }
        if (processingHide) {
            processingHide.style.display = 'none';
        }
        if (processingShow) {
            processingShow.style.display = 'inline-block';
        }

        let queryString = '';
        if (!errorMsg) {
            // call the API with a generic signature
            try {
                const formObj = formToObject(formElement!);
                const response = isMultipartEncoding
                    ? await invokeMultipartEncoding(formObj, apiUrl!)
                    : await invokeJsonEncoding(formObj, apiUrl!);
                if (response.error) {
                    const errors = (<any>response.error).errors ? Object.values((<any>response.error).errors) : [];
                    errorMsg =
                        errors.length > 0 && Array.isArray(errors[0]) && errors[0].length
                            ? errors[0][0]
                            : 'Error no identificado. Verifique los datos o reintente más tarde';
                } else if (response.data?.status) {
                    errorMsg = response.data.message;
                } else {
                    jsonData.value = (<any>response.data).value;
                    repostFormElement.submit();
                }
            } catch (error) {
                errorMsg = error?.toString() || 'Error interno';
            }
        }

        if (processingShow) {
            processingShow.style.display = 'none';
        }

        if (processingHide) {
            processingHide.style.display = 'flex';
        }
        if (errorMsg) {
            if (failurePHolder) {
                failurePHolder.innerHTML = errorMsg;
                failurePHolder.style.display = 'inline-block';
            }
        }
    };

    // start processing state
    processingShow.style.display = 'none';

    if (event === 'submit') {
        // post on submit
        formElement.addEventListener('submit', async function (e: Event) {
            e.preventDefault();
            if (submitHide) {
                submitHide.style.display = 'none';
            }
            await callApi();
            return false;
        });
    } else if (event === 'load') {
        // post on load
        callApi();
    }
}
